// src/browser.ts
export * from "./core/types.js";
export * from "./core/constants.js";
export * from "./core/errors.js";
export { Logger } from "./core/logger.js";

export { initLogger, getLogger, createLogger } from "./init.js";

// Create and export default logger instance
import { getLogger } from "./init.js";
export const logger = getLogger();
